/**
 * Represents a Part Type with its metric limits for Heats
 * Maps to the output of [RBD].[GetPartTypesMetricLimits] stored procedure
 */
export interface PartTypeMetricLimits {
  PartTypeId: number;
  PartTypeName: string;
  MetricTypeId: number;
  MetricTypeName: string;
  CampaignWarningLimit: number;
  CampaignAlertLimit: number;
  PartialWarningLimit: number;
  PartialAlertLimit: number;
  TotalWarningLimit: number;
  TotalAlertLimit: number;
}

/**
 * Initial values for the form (all zeros)
 */
export const METRIC_LIMITS_INITIAL_VALUES: PartTypeMetricLimits = {
  PartTypeId: 0,
  PartTypeName: "",
  MetricTypeId: 1, // Default to "Heats" metric type
  MetricTypeName: "Heats",
  CampaignWarningLimit: 0,
  CampaignAlertLimit: 0,
  PartialWarningLimit: 0,
  PartialAlertLimit: 0,
  TotalWarningLimit: 0,
  TotalAlertLimit: 0,
};
